import React from 'react';
import { Routes, Route } from 'react-router-dom';

import {StakingLanding} from './Landing';
import {Stake} from './Stake';
import {Claim} from './Claim';

import './staking.scss';

export function StakingMain() {
    return <div id="staking">
        <Routes>
            <Route path="/" element={<StakingLanding />} />
            <Route path="/stake" element={<Stake />} />
            <Route path="/claim" element={<Claim />} />
        </Routes>
    </div>
}